import {
  ChartBarIcon,
  CreditCardIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  UsersIcon,
  LockClosedIcon,
  ShieldCheckIcon,
} from "@heroicons/react/outline";
import {
  FaMoneyCheck,
  FaPeopleCarry,
  FaRegCreditCard,
  FaMoneyCheckAlt,
} from "react-icons/fa";
import { FcMoneyTransfer } from "react-icons/fc";
import { Disclosure } from "@headlessui/react";
import { MdPayments } from "react-icons/md";
import { FaExchangeAlt } from "react-icons/fa";
import { SiGooglenews } from "react-icons/si";
import { MdViewModule } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { MdOutlineReportOff } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { AiOutlineAudit } from "react-icons/ai";
import { FcPlanner } from "react-icons/fc";
import { BsPersonBoundingBox } from "react-icons/bs";
import icon from "../../assets/images/icon.svg";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { FaPlane } from "react-icons/fa";

export const navigation = [
  {
    name: "Dashboard",
    tag: "dashboard",
    moduleTag: "dashboard",
    icon: HomeIcon,
    current: false,
    href: "/dashboard",
    children: [{ name: "Overview", href: "/dashboard" }],
  },
  {
    name: "Customer Management",
    moduleTag: "customer",
    icon: UsersIcon,
    tag: "customer",
    current: false,
children: [
    { name: "Customers", href: "/customers" },
    { name: "New to Bank", href: "/new-to-bank" },
    { name: "Onboarding Status History", href: "/onboarding-status-history" },
    { name: "Verification Emails", href: "/verification-emails" },
    { name: "Ratings", href: "/customer/reviews" },
  ],
  },
  {
    name: "Approvals",
    moduleTag: "approvals",
    icon: ShieldCheckIcon,
    tag: "approvals",
    role: "checker",
    current: false,
    children: [
      { name: "Customer Approvals", href: "/approvals" },
      { name: "Account Approvals", href: "/approvals/account-approvals" },
      {
        name: "Account Opening Approvals",
        href: "/approvals/account-opening-approvals",
      },
    ],
  },
  {
    name: "Admin",
    icon: UsersIcon,
    moduleTag: "admin",
    current: false,
    tag: "admin",
    children: [
      { name: "User Management", href: "/users" },
      { name: "Create User", href: "/create/user" },
      { name: "Roles", href: "/roles" },
    ],
  },
  {
    name: "Compliance",
    moduleTag: "accounts",
    icon: LockClosedIcon,
    tag: "compliance",
    current: false,
    children: [
      { name: "Compliance sheet", href: "/compliance/sheets" },
      { name: "Log pND", href: "/compliance/log" },
    ],
  },
  {
    name: "Account Opening",
    moduleTag: "accounts",
    icon: FolderIcon,
    current: false,
    tag: "account",
    children: [
      { name: "Overview", href: "/accounts" },
      { name: "Online Account Opening", href: "/online/accounts" },
      { name: "Liveness Images", href: "/online/accounts/liveness-images" },
      {
        name: "Quick Online Referral Code Account Opening",
        href: "/online/accounts/referral-codes",
      },
      { name: "Minor Accounts", href: "/minor/accounts" },
      { name: "Salary Accounts", href: "/salary/accounts" },
      { name: "Business Accounts", href: "/business/accounts" },
      { name: "Account Officer", href: "/officers" },
      { name: "User Accounts", href: "/user/accounts" },
      { name: "Upgrade Requests", href: "/user/upgrade" },
    ],
  },
  {
    name: "Transfers",
    moduleTag: "transfers",
    icon: InboxIcon,
    tag: "transfers",
    current: false,
    children: [
      { name: "Overview", href: "/transfers" },
      { name: "Scheduled Transfers", href: "/scheduled/transfers" },
      { name: "Beneficiaries", href: "/beneficiaries" },
      // { name: 'General Transfers', href: '/general/transfers' },
      // { name: 'Payroll', href: '/payrolls' }
    ],
  },
  {
    name: "Transaction Utilities",
    moduleTag: "transaction_utilities",
    icon: FaMoneyCheckAlt,
    tag: "transaction_utilities",
    current: false,
    children: [
      { name: "Bank Availability", href: "/utilities" },
      { name: "Reported Accounts", href: "/fraud" },
    ],
  },
  {
    name: "Investments",
    moduleTag: "investment",
    icon: ChartBarIcon,
    tag: "investment",
    current: false,
    children: [
      { name: "Overview", href: "/investments" },
      { name: "Rates Guide", href: "/investments/rate" },
    ],
  },
  //fx_transactions,treasury_bill,fgn_bonds
  {
    name: "FX Exchange",
    moduleTag: "fx_transactions",
    icon: FaExchangeAlt,
    tag: "fx_transactions",
    current: false,
    children: [
      { name: "FX Transactions", href: "/transactions" },
      { name: "FX Rates", href: "/rates" },
    ],
  },
  {
    name: "Treasury Bill",
    icon: UsersIcon,
    moduleTag: "treasury_bill",
    current: false,
    tag: "treasury_bill",
    children: [
      { name: "Listings", href: "/treasury" },
      { name: "Bookings", href: "/bookings" },
      { name: "Liquidation", href: "/liquidation" },
    ],
  },
  // fb_bonds
  {
    name: "FGN Bonds",
    icon: UsersIcon,
    moduleTag: "fgn_bonds",
    current: false,
    tag: "fgn_bonds",
    children: [
      { name: "Listings", href: "/fgn-bonds" },
      { name: "Bookings", href: "/fgn-bonds/bookings" },
      { name: "Liquidation", href: "/fgn-bonds/liquidation" },
      //{ name: 'Eligibility', href: '/fgn-bonds/eligibility' }
    ],
  },
  {
    name: "Cheque / Draft",
    moduleTag: "cheques",
    icon: FaMoneyCheck,
    tag: "cheque",
    current: false,
    children: [
      { name: "Confirm Cheques", href: "/confirm/cheque" },
      { name: "Chequebook Request", href: "/request/cheque" },
      { name: "Stop Cheques", href: "/stop/cheque" },
      { name: "Draft Request", href: "/draft" },
    ],
  },
  {
    name: "Cards",
    moduleTag: "cards",
    icon: FaRegCreditCard,
    tag: "cards",
    current: false,
    children: [
      { name: "Card Requests", href: "/request/card" },
      { name: "Virtual Cards", href: "/virtual/cards" },
      // { name: 'Block Cards', href: '/block/card' },
    ],
  },
  {
    name: "POS Request",
    moduleTag: "pos",
    icon: CreditCardIcon,
    tag: "pos",
    current: false,
    children: [{ name: "POS Requests", href: "/pos" }],
  },
  {
    name: "Payment",
    moduleTag: "payment",
    icon: MdPayments,
    tag: "payment",
    current: false,
    children: [
      { name: "Bill Payment", href: "/payment/bill" },
      { name: "Airtime & Data Recharge", href: "/payment/recharge" },
      { name: "Movie Subscription", href: "/payment/movies" },
    ],
  },
  {
    name: "Deposit",
    moduleTag: "deposit",
    icon: FcMoneyTransfer,
    tag: "deposit",
    current: false,
    children: [{ name: "Overview", href: "/deposits" }],
  },
  {
    name: "Withdrawals",
    icon: MdOutlineAccountBalanceWallet,
    tag: "withdrawal",
    moduleTag: "withdrawal",
    current: false,
    children: [
      { name: "Cash Pickup", href: "/withdrawal/pickup" },
      // { name: 'Cardless Withdrawals', href: '/withdrawals' },
    ],
  },
  {
    name: "News",
    moduleTag: "news",
    icon: SiGooglenews,
    tag: "news",
    current: false,
    children: [
      { name: "All News Feed", href: "/posts" },
      { name: "News Feed", href: "/promotion " },
      { name: "Push Notification", href: "/push/notification" },
      // { name: 'New Post', href: '/create/post' },
      // { name: 'Branch & ATM Locator', href: '/atm/location' }
    ],
  },
  {
    name: "Application Module",
    tag: "application_module",
    icon: MdViewModule,
    moduleTag: "application_module",
    current: false,
    children: [{ name: "Overview", href: "/modules" }],
  },
  {
    name: "Application Settings",
    tag: "application_settings",
    icon: IoMdSettings,
    moduleTag: "application_settings",
    current: false,
    children: [{ name: "Overview", href: "/application/settings" }],
  },
  {
    name: "Complaints",
    tag: "compliant",
    icon: MdOutlineReportOff,
    moduleTag: "compliant",
    current: false,
    children: [{ name: "Overview", href: "/complaints" }],
  },
  {
    name: "Audit Logs",
    tag: "security",
    role: " AiOutlineAudit",
    icon: AiOutlineAudit,
    moduleTag: "security",
    current: false,
    children: [
      { name: "Customer  AuditLogs", href: "/customer/audit" },
      { name: "Admin  AuditLogs", href: "/admin/audit" },
    ],
  },
  {
    name: "Organization",
    tag: "tenure",
    icon: FaBuilding,
    moduleTag: "tenure",
    current: false,
    children: [{ name: "Overview", href: "/organisation" }],
  },
  {
    name: "Loan",
    moduleTag: "loan",
    icon: ChartBarIcon,
    tag: "loan",
    current: false,
    children: [
      { name: "Personal Loans", href: "/loan/personal" },
      { name: "Cashback Loan", href: "/loan/cashback" },
      { name: "PayDay Loan", href: "/loan/payday" },
    ],
  },
  // {
  //   name: 'Rewards Program',
  //   moduleTag:"reward",
  //   icon: ChartBarIcon,
  //   tag: 'reward',
  //   current: false,
  //   children: [
  //     { name: 'Rewards', href: '/rewards' },
  //     { name: 'Referrals', href: '/refarrals' }
  //   ],
  // },
  {
    name: "Budget",
    moduleTag: "budget",
    icon: FcPlanner,
    tag: "budget",
    current: false,
    children: [{ name: "Overview", href: "/budgets" }],
  },
   {
    name: "Wakanow",
    moduleTag: "wakanow",
    icon: FaPlane,
    tag: "wakanow",
    current: false,
    children: [
      { name: "Holiday Packages", href: "/wakanow/holiday-packages" },
      { name: "Holiday Requests", href: "/wakanow/holiday-package-requests" },
      { name: "Flight Bookings", href: "/wakanow/flight-bookings" },
      { name: "Hotel Bookings", href: "/wakanow/hotel-bookings" },
    ],
  },
  {
    name: "PreOnboarding",
    moduleTag: "preonboarding",
    icon: BsPersonBoundingBox,
    tag: "preonboarding",
    current: false,
    children: [{ name: "Overview", href: "/preonboard" }],
  },
  {
    name: "Discount Hub",
    moduleTag: "discount-hub",
    icon: ChartBarIcon,
    tag: "discount-hub",
    current: false,
    children: [
      { name: "Referral Codes", href: "/discount-hub/referral-codes" },
      { name: "Exempted Staff Referral Codes", href: "/discount-hub/staff-referral-codes" },
    ],
  },
  {
    name: "ThirdParty",
    moduleTag: "thirdparty",
    icon: FaPeopleCarry,
    tag: "thirdparty",
    current: false,
    children: [
      { name: "Overview", href: "/thirdparty" },
      { name: "Organizations", href: "/thirdparty/organizations" },
      { name: "Applications", href: "/thirdparty/applications" },
      { name: "Employees", href: "/thirdparty/employees" },
      { name: "Payroll Officers", href: "/thirdparty/payroll-officers" },
      { name: "Pre-Onboarded Officers", href: "/thirdparty/pre-onboarded-payroll-officers" },
      { name: "Payroll Transactions", href: "/thirdparty/payroll-transactions" },
    ],
  },
];



function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const viewPathMap = {
  "/view/online-account": "/online/accounts",
  "/customer/view": "/customers",
};

function resolveActivePath(pathname) {
  return viewPathMap[pathname] || pathname;
}

function getDefaultOpenMenus(pathname) {
  const result = {};
  try {
    const details = sessionStorage.getItem("user");
    if (!details) return result;
    const userDetails = JSON.parse(details);
    const modules = userDetails.moduleAssigned?.split(",") || [];
    modules.push("dashboard");
    const navNeeded = navigation.filter((x) => modules.includes(x.moduleTag));
    const activePath = resolveActivePath(pathname || window.location.pathname);
    navNeeded.forEach((item) => {
      if (!item.children) return;
      const isActive = item.children.some(
        (subItem) =>
          activePath === subItem.href ||
          activePath.startsWith(subItem.href + "/"),
      );
      if (isActive) result[item.name] = true;
    });
  } catch (_) {}
  return result;
}

function getInitialUserNav() {
  try {
    const raw = sessionStorage.getItem("user");
    if (!raw) return [];
    const userDetails = JSON.parse(raw);
    const modules = userDetails.moduleAssigned?.split(",") || [];
    modules.push("dashboard");
    let navNeeded = navigation.filter((x) => modules.includes(x.moduleTag));
    if (userDetails.role !== "SuperAdmin") {
      navNeeded = navNeeded.filter((x) => x.role !== "SuperAdmin");
    }
    if (userDetails.adminType && userDetails.adminType.toLowerCase() === "maker") {
      navNeeded = navNeeded.filter((x) => x.role !== "checker");
    }
    return navNeeded;
  } catch (_) {
    return [];
  }
}

function getInitialUser() {
  try {
    const raw = sessionStorage.getItem("user");
    if (!raw) return { firstName: "", surname: "" };
    return JSON.parse(raw);
  } catch (_) {
    return { firstName: "", surname: "" };
  }
}

export default function SideBar({ currentPage, parentPage }) {
  const location = useLocation();
  const [user, setUser] = useState(getInitialUser);
  const [userNav, setUserNav] = useState(getInitialUserNav);
  const [openMenus, setOpenMenus] = useState(getDefaultOpenMenus);

  const getDetails = () => {
    var details = sessionStorage.getItem("user");
    if (!details) return;
    var userDetails = JSON.parse(details);
    var modules = [];
    modules = userDetails.moduleAssigned.split(",").map(module => module.trim());
    modules.push("dashboard");

    var navNeeded = navigation.filter((x) => modules.includes(x.moduleTag));

    if (userDetails.role !== "SuperAdmin") {
      navNeeded = navNeeded.filter((x) => x.role !== "SuperAdmin");
    }

    if (userDetails.adminType) {
      if (userDetails.adminType.toLowerCase() === "maker") {
        navNeeded = navNeeded.filter((x) => x.role !== "checker");
      }
    }

    setUserNav([...navNeeded]);
    setUser(userDetails);
  };

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => {
      // If clicking the already open menu, close it
      if (prev[menuName]) {
        return { ...prev, [menuName]: false };
      }
      // Otherwise, close all menus and open only the clicked one
      const newState = {};
      // Close all menus
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
      });
      // Open the clicked menu
      newState[menuName] = true;
      return newState;
    });
  };

  useEffect(() => {
    getDetails();
  }, [location.pathname]);

  useEffect(() => {
    setOpenMenus(getDefaultOpenMenus(location.pathname));
  }, [location.pathname]);
  
  return (
    <>
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 btn-primary overflow-auto">
        <div className="flex justify-center flex-shrink-0 px-4 my-5">
          <div className="flex ">
            <img className="w-auto" src={icon} alt="icon" />
          </div>
        </div>
        <div className="flex border-y-stone-300 m-2 p-2 justify-center dashboard-avatar">
          <div className="flex-shrink-0 mr-4 bg-white rounded-full h-10 w-10">
            <div className="text-center mt-2 font-extrabold">
              <div>
                <p>
                  {user.firstName?.charAt(0) || ""}
                  {user.surname?.charAt(0) || ""}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <p className="text-white">
              {user.firstName} {user.surname}
            </p>
            {user.adminType && (
              <span className="ml-2 text-xs bg-yellow-200 text-gray-800 px-2 py-1 rounded-full">
                {user.adminType}
              </span>
            )}
          </div>
        </div>

        <div className="mt-5 flex-grow flex flex-col">
          <nav
            className="flex-1 px-2 space-y-1 bg-primary"
            aria-label="Sidebar"
          >
            {userNav.map((item) => {
              const resolvedPath = resolveActivePath(location.pathname);
              const isParentActive = item.children?.some(
                (subItem) =>
                  resolvedPath === subItem.href ||
                  resolvedPath.startsWith(subItem.href + "/"),
              );
              
              return !item.children ? (
                <Link
                  key={item.name}
                  to={item.href || "#"}
                  className={classNames(
                    location.pathname === item.href
                      ? "bg-gray-200 text-black"
                      : "bg-white text-black hover:bg-gray-50 hover:text-black",
                    "group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md",
                  )}
                >
                  <item.icon
                    className={classNames(
                      location.pathname === item.href
                        ? "text-black"
                        : "text-black group-hover:text-black",
                      "mr-3 flex-shrink-0 h-6 w-6",
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </Link>
              ) : (
                // Using a div wrapper instead of Disclosure component to have full control
                <div key={item.name} className="space-y-1">
                  <button
                    onClick={() => toggleMenu(item.name)}
                    className={classNames(
                      openMenus[item.name] || isParentActive ? "bg-gray-100" : "",
                      "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md parent-menu-button hover:bg-gray-100"
                    )}
                  >
                    <item.icon
                      className={classNames(
                        openMenus[item.name] || isParentActive ? "text-black" : "text-white",
                        "mr-3 flex-shrink-0 h-6 w-6 group-hover:text-black"
                      )}
                      aria-hidden="true"
                    />
                    <span
                      className={classNames(
                        openMenus[item.name] || isParentActive ? "text-black" : "text-gray-200",
                        "parent-menu flex-1 group-hover:text-black"
                      )}
                    >
                      {item.name}
                    </span>
                    <svg
                      className={classNames(
                        openMenus[item.name] || isParentActive ? "text-black rotate-90" : "text-gray-200",
                        "ml-3 flex-shrink-0 h-5 w-5 transform transition-transform duration-150 ease-in-out group-hover:text-black"
                      )}
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      style={{
                        transform: openMenus[item.name] || isParentActive ? "rotate(90deg)" : "rotate(0deg)"
                      }}
                    >
                      <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                    </svg>
                  </button>
                  
                  {(openMenus[item.name] || isParentActive) && (
                    <div className="space-y-1">
                      {item.children.map((subItem) => {
                        const resolvedPath = resolveActivePath(location.pathname);
                        const hasDeeperMatch = item.children.some(
                          other => other !== subItem &&
                            other.href.length > subItem.href.length &&
                            (resolvedPath === other.href ||
                             resolvedPath.startsWith(other.href + "/"))
                        );
                        const isActive = !hasDeeperMatch && (
                          resolvedPath === subItem.href ||
                          resolvedPath.startsWith(subItem.href + "/")
                        );
                        return (
                          <Link
                            key={subItem.href}
                            to={subItem.href}
                            className={classNames(
                              isActive
                                ? "bg-gray-200 text-black"
                                : "text-white hover:text-black hover:bg-gray-50",
                              "group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium rounded-md"
                            )}
                          >
                            {subItem.name}
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
}
